var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-\u8FD0\u8425\u5355\u5143\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-105.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-\\u8FD0\\u8425\\u5355\\u5143\\u6570",
    transform: "translate(105.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u591A\\u8FB9\\u5F62",
    fillOpacity: 0.122809563,
    fill: "#FFFFFF",
    points: "34.5 0 64.3778764 17.25 64.3778764 51.75 34.5 69 4.62212357 51.75 4.62212357 17.25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar-check-outlined",
    transform: "translate(15.000000, 14.000000)",
    fill: "#15E3FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25,8.75 L30,8.75 L30,6.5625 C30,6.390625 29.859375,6.25 29.6875,6.25 L27.5,6.25 C27.328125,6.25 27.1875,6.390625 27.1875,6.5625 L27.1875,8.75 L21.40625,8.75 L21.40625,6.5625 C21.40625,6.390625 21.265625,6.25 21.09375,6.25 L18.90625,6.25 C18.734375,6.25 18.59375,6.390625 18.59375,6.5625 L18.59375,8.75 L12.8125,8.75 L12.8125,6.5625 C12.8125,6.390625 12.671875,6.25 12.5,6.25 L10.3125,6.25 C10.140625,6.25 10,6.390625 10,6.5625 L10,8.75 L3.75,8.75 C3.05859375,8.75 2.5,9.30859375 2.5,10 L2.5,32.5 C2.5,33.1914062 3.05859375,33.75 3.75,33.75 L36.25,33.75 C36.9414062,33.75 37.5,33.1914062 37.5,32.5 L37.5,10 C37.5,9.30859375 36.9414062,8.75 36.25,8.75 Z M34.6875,30.9375 L5.3125,30.9375 L5.3125,11.5625 L10,11.5625 L10,13.75 C10,13.921875 10.140625,14.0625 10.3125,14.0625 L12.5,14.0625 C12.671875,14.0625 12.8125,13.921875 12.8125,13.75 L12.8125,11.5625 L18.59375,11.5625 L18.59375,13.75 C18.59375,13.921875 18.734375,14.0625 18.90625,14.0625 L21.09375,14.0625 C21.265625,14.0625 21.40625,13.921875 21.40625,13.75 L21.40625,11.5625 L27.1875,11.5625 L27.1875,13.75 C27.1875,13.921875 27.328125,14.0625 27.5,14.0625 L29.6875,14.0625 C29.859375,14.0625 30,13.921875 30,13.75 L30,11.5625 L34.6875,11.5625 L34.6875,30.9375 Z M16.25,19.375 L9.0625,19.375 C8.890625,19.375 8.75,19.515625 8.75,19.6875 L8.75,21.5625 C8.75,21.734375 8.890625,21.875 9.0625,21.875 L16.25,21.875 C16.421875,21.875 16.5625,21.734375 16.5625,21.5625 L16.5625,19.6875 C16.5625,19.515625 16.421875,19.375 16.25,19.375 Z M16.25,24.6875 L9.0625,24.6875 C8.890625,24.6875 8.75,24.828125 8.75,25 L8.75,26.875 C8.75,27.046875 8.890625,27.1875 9.0625,27.1875 L16.25,27.1875 C16.421875,27.1875 16.5625,27.046875 16.5625,26.875 L16.5625,25 C16.5625,24.828125 16.421875,24.6875 16.25,24.6875 Z M28.2890625,17.7578125 L24.2421875,23.3710938 L22.1796875,20.515625 C22.0625,20.3515625 21.875,20.2578125 21.6757812,20.2578125 L19.53125,20.2578125 C19.2773437,20.2578125 19.1289062,20.546875 19.2773437,20.7539062 L23.734375,26.9335938 C23.984375,27.2773438 24.4921875,27.2773438 24.7421875,26.9335938 L31.1875,18 C31.3359375,17.7929688 31.1875,17.5039063 30.9335938,17.5039063 L28.7890625,17.5039063 C28.59375,17.5 28.40625,17.5976563 28.2890625,17.7578125 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOu);
export default __webpack_public_path__ + "static/media/ou.872dce36c6748b497c0dd59cf965f96f.svg";
export { ForwardRef as ReactComponent };